import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import './FeedbackForm.css';

const FeedbackForm = () => {
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [visited, setVisited] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (rating === 0) { setError('Please select a star rating.'); return; }
        setSubmitting(true);
        setError(null);

        const { error: dbError } = await supabase.from('feedback').insert([
            { name, message, rating, visited, show_on_homepage: false },
        ]);

        if (dbError) {
            setError('Something went wrong. Please try again.');
        } else {
            setSubmitted(true);
        }
        setSubmitting(false);
    };

    if (submitted) {
        return (
            <div className="fb-page">
                <div className="fb-card fb-success-card">
                    <div className="fb-success-icon">🎉</div>
                    <h2>Thank You!</h2>
                    <p>Your feedback has been submitted successfully.<br />We truly appreciate you sharing your experience with us.</p>
                    <div className="fb-brand">
                        <span>✈️</span> Silver Sky Holidays
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="fb-page">
            {/* Brand header */}
            <div className="fb-brand-header">
                <span>✈️</span> Silver Sky Holidays
            </div>

            <div className="fb-card">
                <div className="fb-card-top">
                    <h2>Share Your Experience</h2>
                    <p>Your feedback helps us make every journey unforgettable.</p>
                </div>

                <form onSubmit={handleSubmit} className="fb-form">
                    {/* Star Rating */}
                    <div className="fb-field">
                        <label>Your Rating <span className="fb-required">*</span></label>
                        <div className="fb-stars">
                            {[1, 2, 3, 4, 5].map(star => (
                                <button
                                    key={star}
                                    type="button"
                                    className={`fb-star ${(hoverRating || rating) >= star ? 'active' : ''}`}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onMouseLeave={() => setHoverRating(0)}
                                    onClick={() => setRating(star)}
                                    aria-label={`${star} star`}
                                >
                                    ★
                                </button>
                            ))}
                            {rating > 0 && (
                                <span className="fb-star-label">
                                    {['', 'Poor', 'Fair', 'Good', 'Great', 'Excellent!'][rating]}
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Name */}
                    <div className="fb-field">
                        <label htmlFor="fb-name">Your Name <span className="fb-required">*</span></label>
                        <input
                            id="fb-name"
                            type="text"
                            placeholder="e.g. Rahul Mehta"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            required
                        />
                    </div>

                    {/* Place Visited */}
                    <div className="fb-field">
                        <label htmlFor="fb-visited">Place Visited <span className="fb-required">*</span></label>
                        <input
                            id="fb-visited"
                            type="text"
                            placeholder="e.g. Bali, Switzerland, Dubai..."
                            value={visited}
                            onChange={e => setVisited(e.target.value)}
                            required
                        />
                    </div>

                    {/* Message */}
                    <div className="fb-field">
                        <label htmlFor="fb-message">Your Feedback <span className="fb-required">*</span></label>
                        <textarea
                            id="fb-message"
                            placeholder="Tell us about your travel experience with Silver Sky Holidays..."
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            required
                        />
                    </div>

                    {error && <p className="fb-error"><i className="fa-solid fa-circle-exclamation" /> {error}</p>}

                    <button type="submit" className="fb-submit" disabled={submitting}>
                        {submitting
                            ? <><i className="fa-solid fa-spinner fa-spin" /> Submitting...</>
                            : <><i className="fa-solid fa-paper-plane" /> Submit Feedback</>}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default FeedbackForm;
